import { loadStripe } from "@stripe/stripe-js";

import { AppConfig } from "~/AppConfig";

export const stripePromise = loadStripe(AppConfig.STRIPE_PUBLISHABLE_KEY);
